import _ from "lodash";
import { Outlet } from "react-router-dom";

export default function TeacherWorkshop() {
  return (
    <>
      <Outlet />
    </>
  );
};